import { Case, Slide } from "pwapi";

type PrintSlideState = {
  slide?: Slide;
  case?: Case;
};

const initialState = {
  slide: undefined,
};

const printReducer = (
  state: PrintSlideState = initialState,
  action: any
): PrintSlideState => {
  switch (action.type) {
    default:
      return state;
  }
};
export default printReducer;
